import React from 'react';
import { Group, ThemeIcon, UnstyledButton, Text } from '@good/ui/core';
import { Users, ChevronDown, ChevronUp } from '@good/icons';
import { ROSTER_DAILY_CONFIG } from '../roster-daily-config';

interface ContentGroupHeaderProps {
  text: string;
  onClick: () => void;
  isOpen: boolean;
}

export function ColumnGroupHeader({ text, onClick = () => {}, isOpen = true }: ContentGroupHeaderProps) {
  const { CONTENT_GROUP_HEIGHT } = ROSTER_DAILY_CONFIG;

  return (
    <UnstyledButton w='100%' h={CONTENT_GROUP_HEIGHT} onClick={onClick} px='md' className='bg-tertiary'>
      <Group wrap='nowrap' gap={4} justify='space-between'>
        <Group gap='xs'>
          <ThemeIcon variant='transparent' fz='sm' color='gray'>
            <Users />
          </ThemeIcon>
          <Text fw={550} size='sm'>
            {text}
          </Text>
        </Group>
        {isOpen ? (
          <ThemeIcon variant='transparent' fz='lg' color='gray'>
            <ChevronDown />
          </ThemeIcon>
        ) : (
          <ThemeIcon variant='transparent' fz='lg' color='gray'>
            <ChevronUp />
          </ThemeIcon>
        )}
      </Group>
    </UnstyledButton>
  );
}
